import Theme from "Resources/Theme.json";

export default (rem=1) => {
	return `${((!isNaN(rem) ? rem : 1) * (Theme.App.spacing / 10))}rem`;
};
